import styled from 'styled-components'

// Icons
import { ReactComponent as CheckmarkIcon } from 'icons/checkmark-circle-filled-12.svg'

// Images
import DiamondBackground from './images/diamond-background.png'

// Utils
import { breakpoint } from 'utils'

// Components
import Modal from 'components/Modal'
import Button, { LinkButton } from 'components/Button'

export const StyledModal = styled(Modal)`
  max-width: 640px;
`

export const Title = styled.h1`
  font-size: ${({ theme }) => theme.fontSizes.xlarge};
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
  text-align: center;
`

export const SubTitle = styled.h3`
  margin-top: 0;
  font-size: ${({ theme }) => theme.fontSizes.large};
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`

export const Columns = styled.div`
  display: flex;
  justify-content: center;

  ${breakpoint('base', 'xs')`
    flex-direction: column;
  `}
`

export const Column = styled.div<{ withBackground?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 24px 20px;
  border: 1px solid ${({ theme }) => theme.colors.shadow.outer};
  border-radius: ${({ theme }) => theme.radii.xlarge};
  flex: 1;

  :last-child {
    background-image: url(${DiamondBackground});
    background-size: cover;
    margin: 0 0 0 16px;

    ${breakpoint('base', 'xs')`
      margin: 0 0 16px 0;
    `}
  }
`

export const Paragraph = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.smaller};
  line-height: ${({ theme }) => theme.lineHeights[4]};
`

export const Note = styled.p`
  padding-top: 24px;
  font-size: ${({ theme }) => theme.fontSizes.little};
  color: ${({ theme }) => theme.colors.foreground.secondary[4]};
  text-align: center;
`

export const StyledButton = styled(Button)`
  margin-top: auto;
`

export const StyledLinkButton = styled(LinkButton)`
  margin-top: auto;
`

export const List = styled.ul`
  margin: 0px 0px 24px 0px;
  padding: 0px;
  list-style: none;
`

export const Item = styled.li`
  display: flex;
  font-size: ${({ theme }) => theme.fontSizes.smaller};
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};

  :not(:last-child) {
    padding-bottom: 12px;
  }
`

export const Checkmark = styled(CheckmarkIcon)`
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 8px;
`
